<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
				<div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Actividad de seguimiento">
					<div class="container-fluid">
						<div class="row" id="slide-1">
							<div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 ">
								<div class="p-3 pl-lg-5">
									<h2 class="mt-5">Actividad de seguimiento</h2>
									<h3>Teorías del desarrollo </h3>
									<h5>Tipo de actividad: cuestionario</h5>
									<h4 class="mt-3 pt-xl-5 pt-lg-5 pt-3">Objetivo</h4>
									<p>Reconocer las nociones básicas de la historia de LSC.</p>
									<h4 class="mt-3">¿Qué hacer?</h4>
                                    <p>Lea con atención los enunciados y seleccione la respuesta que considere correcta.</p>
                                </div>
							</div>
							<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-AS justify-content-center align-items-center"> 
                                <p class="RefimgActiv">Foto de Ave Calvar Martinez en <a class="text-white" href="https://www.pexels.com/es-es/foto/blanco-y-negro-persona-manos-sujetando-4061218/" target="_blank">Pexels</a></p>
                                <div class="w-100 pl-lg-3 pr-lg-3 pl-1 pr-1 pt-5 mt-lg-5 mb-5 pb-5">
									<div class="row ml-xl-3 bg-white ml-lg-1 ml-0 mr-xl-3 mr-lg-1 mr-0 vh-xl-100 p-4">
                                        <div class="col-12 mb-4">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>1. Uno de los primeros trabajos de la literatura y la filosofía que abordó el desarrollo y la formación del niño fue:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                     <button v-b-popover.click.blur.html='respuesta1Neg' class="Radiobutton checkAE mr-2 checkAE_1" id="checkAE_1_A" @click="activar($event,1)"></button>
                                                   </div>
                                                   <p>a) <span class="font-italic">El Contrato Social</span> de Rousseau</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html="respuesta1Pos" class="Radiobutton checkAE mr-2 checkAE_1" id="checkAE_1_B" @click="activar($event,1)"></button>
                                                   </div>
                                                   <p>b) <span class="font-italic">Emilio</span> de Rousseau</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>2. Según la historia de la infancia y los diversos hitos que fueron marcando los pilares sobre el cuidado en la dimensión del niño, se puede indicar que estos hitos fueron:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html="respuesta2Pos" class="Radiobutton checkAE mr-2 checkAE_2" id="checkAE_2_A" @click="activar($event,2)"></button>
                                                   </div>
                                                   <p>a) Las investigaciones sobre la psicomotricidad y la ciencia de la pediatría.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta2Neg' class="Radiobutton checkAE mr-2 checkAE_2" id="checkAE_2_B" @click="activar($event,2)"></button>
                                                   </div>
                                                   <p>b) Las investigaciones en pedagogía de los niños y la ciencia de la pediatría. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>3. Los tres aspectos básicos de la teoría cognitiva en relación al desarrollo de los niños y niñas son:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html="respuesta3Neg" class="Radiobutton checkAE mr-2 checkAE_3" id="checkAE_3_A" @click="activar($event,3)"></button>
                                                   </div>
                                                   <p>a) La adaptación de la memoria, la adaptación de la inteligencia y las relaciones cognitivas. </p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html='respuesta3Pos' class="Radiobutton checkAE mr-2 checkAE_3" id="checkAE_3_B" @click="activar($event,3)"></button>
                                                   </div>
                                                   <p>b) La adaptación del organismo, la adaptación de la inteligencia y las relaciones cognitivas. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>4. Los conceptos de <span class="font-italic">organización y adaptación</span> son fundamentales en la teoría cognitiva, porque describen, en su orden:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html='respuesta4Pos' class="Radiobutton checkAE mr-2 checkAE_4" id="checkAE_4_A" @click="activar($event,4)"></button>
                                                   </div>
                                                   <p>a) En la organización se encuentran los mecanismos biológicos innatos, con que cuentan los niños para el desarrollo. En la adaptación, se identifica el proceso de ajuste con el ambiente. </p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html="respuesta4Neg" class="Radiobutton checkAE mr-2 checkAE_4" id="checkAE_4_B" @click="activar($event,4)"></button>
                                                   </div>
                                                   <p>b) En la organización se identifican los procesos de la inteligencia, que se adaptan al ambiente.</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>5. La reorganización de la información, que consiste en la estructuración de los esquemas previos, se denomina…</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                         <button v-b-popover.click.blur.html="respuesta5Pos" class="Radiobutton checkAE mr-2 checkAE_5" id="checkAE_5_A" @click="activar($event,5)"></button>
                                                   </div>
                                                   <p>a) Acomodación</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html='respuesta5Neg' class="Radiobutton checkAE mr-2 checkAE_5" id="checkAE_5_B" @click="activar($event,5)"></button>
                                                   </div>
                                                   <p>b) Asimilación</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                            <button class="btn BtnPrincipal d-flex mx-auto mt-4 mb-4" @click="recargarPagina">Intentar nuevamente</button>
                                        </div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
        </div>
    </div>
</template>

<script>
import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'ActividadSeguimiento',
    data(){
      return{
        respuesta1Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">En este tratado, Rousseau (1985) cataloga la forma como se ha visto la educación en su época, y la rechaza por considerar que va en contra del hombre. Contrario a esto, propone una formación centrada en las satisfacción del deseo y el alcance de la felicidad en los individuos. </p>',
        respuesta1Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',
        
        respuesta2Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">El primero de estos pilares serían las investigaciones médicas dadas a principios del siglo XX en el marco de la primera guerra mundial (1914-1918) donde los médicos identificarían el concepto de psicomotricidad.</p>',
        respuesta2Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',

        respuesta3Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Los tres procesos son, en primer lugar, la adaptación que tiene un organismo con su entorno, identificando sus formas de regulación, interacción y autorregulación; en segundo lugar, se encuentra la adaptación de la inteligencia, que se ejemplifica en los procesos internos que permiten la inteligencia, como su adquisición a través de la experiencia; y, por último, se establece la investigación sobre las relaciones cognitivas.</p>',
        respuesta3Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',
        
        respuesta4Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">La organización es el fundamento por el cual hay una predisposición innata en las especies.</p>',
        respuesta4Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',

        respuesta5Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">La asimilación es el manejo de información nueva que va transformando la información anterior. Implica una actitud activa de los niños y la niñas, por lo que se va desarrollando un esquema de reorganización de información continuamente a través de los datos que se reciben y de la reorganización interna que se produce. </p>',
        respuesta5Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',

        popovers:[false,false,false,false,false]
      }
    },
    methods: {
    activar: function(event,numPregunta){
   
      let elementosGrupo=document.querySelectorAll(".checkAE_"+numPregunta);
     
      elementosGrupo.forEach(element => {
          element.classList.remove("active","i-check");
      });

     event.target.classList.add("active","i-check");

    //    elementosGrupo.forEach(element => {
    //     element.style.pointerEvents='none';
    //    });

    },

    recargarPagina: function(){
        location.reload();
    }
  },
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title // Cambiar el título de la página
    }
}
</script>